{
  "schemaVersion": 1,
  "key": "futuristic",
  "name": "Futuristic",
  "version": "1.0.0",
  "author": "classy core",
  "backgrounds": {
    "home": "backgrounds/minimal_future.png"
  },
  "mascot": {
    "home": "mascot/robot.png"
  },
  "tokens": {
    "accent": "#FA7FAF"
  }
}
